import { Component, Input } from '@angular/core';

@Component({
    template: ''
})
export class MessageComponent {
    @Input() text: string = '';
    @Input() text2?: string = '';
    type: string = '';
    enabledButtons: boolean = true;
}
